import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { RosterGrid } from "@/components/RosterGrid";
import { CalendarRange } from "lucide-react";

export default function MyRosterDialog({ open, onClose, initialDate }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-3xl overflow-y-auto" data-testid="my-roster-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><CalendarRange className="h-5 w-5" /> {t("My roster")}</DialogTitle>
          <DialogDescription>{t("Your rostered days for the pay period. Ask your manager to change anything.")}</DialogDescription>
        </DialogHeader>
        {open && <RosterGrid editable={false} endpoint="/my/roster" compact initialDate={initialDate} />}
      </DialogContent>
    </Dialog>
  );
}
